import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function InputPopup({ isModalOpen, onClose }) {
  return (
    <Modal className="reports-modal input-modal" show={isModalOpen} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <h5 className="module-title">Throughout the input screen, you will notice different icons to help ease the process. Below are detailed explanations for each icon.</h5>
          <div className="row first-row input-popup-row">
            <div className="col-md-4 input-popup-col">
              <div className="card mandatory">
                <div className="card-header">
                  <h5>Mandatory</h5>
                  <div>
                    <img src="./assets/img/reports/Mandatory.svg" alt="" />
                  </div>
                </div>

                <div className="card-body">
                  <ul>
                    <li>These are non-negotiable requirements set by ESRS standards that your company must report to ensure compliance.</li>
                    <li>Make sure you disclose the necessary reporting requirements established by regulatory bodies.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 input-popup-col">
              <div className="card voluntary">
                <div className="card-header">
                  <h5>Voluntary</h5>
                  <div>
                    <img src="./assets/img/reports/voluntary.svg" alt="" />
                  </div>
                </div>
                <div className="card-body">
                  <ul>
                    <li>These disclosures focus on encouraging companies to provide extra information beyond what is legally required.</li>
                    <li>You can choose these voluntary disclosures to emphasize your transparency and accountability in the reporting.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 input-popup-col">
              <div className="card phased-in">
                <div className="card-header">
                  <h5>Phased in</h5>
                  <div>
                    <img src="./assets/img/reports/phased-in.svg" alt="" />
                  </div>
                </div>
                <div className="card-body">
                  <ul>
                    <li>Disclosure requirements phased in by regulations, allowing you to be skipped initially but requires you to disclose over time.</li>
                    <li>The proposed timeline for the disclosure is provided along with their effective dates.</li>
                    <li>It's essential for your organization to prepare for their eventual implementation.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row first-row input-popup-row">
            <div className="col-md-4 input-popup-col">
              <div className="card eu-reg">
                <div className="card-header">
                  <h5>Alignment with other EU Regulations</h5>
                  <div style={{ padding: "0" }}>
                    <img src="./assets/img/reports/eu-reg.png" style={{ width: "50px", marginTop: "-3px", marginLeft: "-5px" }} alt="" />
                  </div>
                </div>

                <div className="card-body">
                  <ul>
                    <li>These are data points that are aligned with other EU regulations (such as SFDR, Pillar 3, Benchmark Regulation, EU Climate Law). If this data point is material to your company, you must report on that to ensure compliance.</li>
                    <li>If it is not material, you can explicitly mention that "it is not material"</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 input-popup-col">
              <div className="card info">
                <div className="card-header">
                  <h5>Information (i) icon</h5>
                  <div>
                    <img src="./assets/img/reports/info.svg" alt="" />
                  </div>
                </div>

                <div className="card-body">
                  <ul>
                    <li>Beside each disclosure title, you'll find this (i) icon, indicating the disclosure requirement and offering a clearer understanding of the necessary materials and provides a brief overview of the specific disclosure as per ESRS standards.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4 input-popup-col">
              <div className="card ai">
                <div className="card-header">
                  <h5>Generate with AI</h5>
                  <div>
                    <img src="./assets/img/reports/ai.svg" alt="" />
                  </div>
                </div>

                <div className="card-body">
                  <ul>
                    <li>Click the "Generate with AI" button at the top AI will extract data from uploaded repository files and generate answers for qualitative disclosure requirements.</li>
                    <li>Verify the generated answers to ensure accuracy and completeness before finalizing your report.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <label htmlFor="doNotShowAgain" className="checkbox-label">
          <input
            type="checkbox"
            id="doNotShowAgain"
            name="doNotShowAgain"
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem("popup3", "false");
              } else {
                localStorage.setItem("popup3", "true");
              }
            }}
          />
          Don't show this message again
        </label>
        <div className="button-group">
          <Button variant="outline-secondary" className="cancel-button" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" className="next-button" onClick={onClose}>
            Okay
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default InputPopup;
